import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Download } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { trackUserAction } from "@/utils/tracking";

const CompanyFiles = () => {
  const { data: files, isLoading } = useQuery({
    queryKey: ['downloadable-files'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('downloadable_files')
        .select('*')
        .order('created_at', { ascending: true });
      
      if (error) throw error;
      return data;
    },
  });

  const handleDownload = async (file: { title: string; file_url: string }) => {
    await trackUserAction('download', { file_name: file.title });
    window.open(file.file_url, '_blank');
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-xl text-primary flex items-center gap-2">
            <Download className="h-6 w-6" />
            Company Files
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            {isLoading ? (
              <div className="text-center py-8">Loading files...</div>
            ) : files?.length === 0 ? (
              <div className="text-center py-8 text-muted-foreground">
                No files available
              </div>
            ) : (
              files?.map((file) => (
                <div
                  key={file.id}
                  className="flex items-center justify-between p-4 rounded-lg border hover:bg-accent/50 transition-colors"
                >
                  <div>
                    <h4 className="font-semibold text-primary-dark">
                      {file.title}
                    </h4>
                    {file.description && (
                      <p className="text-sm text-muted-foreground">
                        {file.description}
                      </p>
                    )}
                  </div>
                  <Button
                    variant="outline"
                    className="flex items-center gap-2"
                    onClick={() => handleDownload(file)}
                  >
                    <Download className="h-4 w-4" />
                    Download
                  </Button>
                </div>
              ))
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CompanyFiles;